import Vue from "vue"
import Router from "vue-router"

import LogIn from "./views/LogIn.vue"
import Pages from "./views/Pages.vue"
import Profile from "./views/Profile.vue"
import Users from "./views/Users.vue"
import Find from "./views/Find.vue"
Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "sel",
  routes: [
    {
      path: "/",
      name: "root",
      component: LogIn,
      meta: { isPublic: true }
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile
    },
    {
      path: "/users",
      name: "users",
      component: Users
    },
    {
      path: "/find",
      name: "find",
      component: Find
    },
    {
      path: "/pages/:type",
      name: "pages",
      component: Pages
    },
    {
      path: "/pages/:type/edit/:id",
      name: "page-edit",
      component: () => import(/* webpackChunkName: "page-edit" */ "./views/PageEdit.vue")
    }
  ]
})
